import axios from "axios";
import { getAuthHeaders } from "./auth";

const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:7071/api";

export interface SystemSetting {
  keyName: string;
  value: string;
  description: string;
}

export async function listSettings(): Promise<SystemSetting[]> {
  const resp = await axios.get(`${BASE_URL}/manage/settings`, { headers: getAuthHeaders() });
  return resp.data.settings as SystemSetting[];
}

/**
 * PATCH a setting's value by key.
 *
 * Empty string is a valid value (e.g., clearing the admin group ID disables
 * admin checks until it's reset). The server returns the full updated row.
 */
export async function updateSetting(keyName: string, value: string): Promise<SystemSetting> {
  const resp = await axios.patch(
    `${BASE_URL}/manage/settings/${encodeURIComponent(keyName)}`,
    { value },
    { headers: getAuthHeaders() }
  );
  return resp.data as SystemSetting;
}
